import { DependencyList, useEffect, useState } from "react"

export interface UseOnlineListState
{
    loading: boolean;
    online_list: (string | null)[];
}

function useOnlineList(
    getOnlineList: () => Promise<Array<string | null>>,
    deps: DependencyList = [],
    options?: { delay?: number },
)
{
    const [state, setState] = useState({
        loading: false,
        online_list: [] as Array<string | null>
    });

    const start = async () =>
    {
        setState(prev => ({ ...prev, loading: true }));

        try
        {
            const res = await getOnlineList();

            setState(prev => ({
                ...prev,
                online_list: res,
                loading: false
            }));
        } 
        catch
        {
            setState(prev => ({ ...prev, loading: false }));
        }
    };

    useEffect(() =>
    {
        start();

        const interval = setInterval(start, options?.delay ?? 30_000);

        return () => clearInterval(interval);

        // eslint-disable-next-line
    }, [options?.delay, ...deps]);

    return state;
}

export default useOnlineList;